import defaultAttributes from '../defaultAttributes';
import type { IconNode } from '../types';

const Reply: IconNode = [
  'svg',
  defaultAttributes,
  [
    ['polyline', { points: '9 17 4 12 9 7' }],
    ['path', { d: 'M20 18v-2a4 4 0 0 0-4-4H4' }],
  ],
];

export default Reply;
